import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import App from '../../../../src/App.tsx'

import createAuthRequiredPage from "./auth/pages/createAuthRequiredPage"

import { LoginPage } from '../../../../src/auth/email/LoginPage.tsx'
import { SignupPage } from '../../../../src/auth/email/SignupPage.tsx'
import { RequestPasswordResetPage } from '../../../../src/auth/email/RequestPasswordResetPage.tsx'
import { PasswordResetPage } from '../../../../src/auth/email/PasswordResetPage.tsx'
import { EmailVerificationPage } from '../../../../src/auth/email/EmailVerificationPage.tsx'
import { VerifyEmailLandingPage } from '../../../../src/auth/email/VerifyEmailLandingPage.tsx'
import { LandingPageWrapper as LandingPage } from '../../../../src/LandingPageWrapper.tsx'
import AppLayoutPage from '../../../../src/routes/AppLayout.tsx'
import { DashboardPage as V32DashboardPage } from '../../../../src/v32/pages/DashboardPage.tsx'
import { RecipePage as V32RecipePage } from '../../../../src/v32/pages/RecipePage.tsx'
import { MyRecipesPage as V32MyRecipesPage } from '../../../../src/v32/pages/MyRecipesPage.tsx'
import { RecipeManagerPage } from '../../../../src/v32/pages/manager/RecipeManagerPage.tsx'
import { FavoritesRedirect as V32FavoritesRedirectPage } from '../../../../src/v32/pages/FavoritesRedirect.tsx'
import { SharedRecipePage } from '../../../../src/v32/pages/SharedRecipePage.tsx'
import { PlansPage as V32PlansPage } from '../../../../src/v32/pages/PlansPage.tsx'
import { ShoppingListPage } from '../../../../src/pages/ShoppingListPage'
import { ComingSoon as ComingSoonPage } from '../../../../src/v32/pages/ComingSoon'
import { AnalyticsDashboard as AnalyticsDashboardPage } from '../../../../src/pages/AnalyticsDashboard'
import { RecipeDetailPage as V32RecipeDetailPage } from '../../../../src/v32/pages/RecipeDetailPage.tsx'
import { CookingModePage as V32CookingModePage } from '../../../../src/v32/pages/CookingModePage.tsx'
import { RecipeRedirect as RecipeRedirectPage } from '../../../../src/v32/pages/RecipeRedirect.tsx'
import { CreateCustomRecipePage as V32CreateCustomRecipePage } from '../../../../src/v32/pages/CreateCustomRecipePage.tsx'
import { SemanticSearchTest as V32SemanticSearchTestPage } from '../../../../src/v32/pages/SemanticSearchTest.tsx'
import { StandardProfilePage } from '../../../../src/v32/pages/StandardProfilePage.tsx'
import { ProfilePage as V32ProfilePage } from '../../../../src/v32/pages/ProfilePage.tsx'
import { SettingsPage as V32SettingsPage } from '../../../../src/v32/pages/SettingsPage.tsx'
import { PricingPage as V32PricingPage } from '../../../../src/v32/pages/PricingPage.tsx'
import BetaPricingPage from '../../../../src/pages/BetaPricingPage.tsx'
import V32AdminUsagePage from '../../../../src/v32/pages/admin/AdminUsagePage.tsx'
import V32AdminPlansPage from '../../../../src/v32/pages/admin/AdminPlansPage.tsx'
import V32AdminBillingPage from '../../../../src/v32/pages/admin/AdminBillingPage.tsx'
import V32AdminAIPage from '../../../../src/v32/pages/admin/AdminAIPage.tsx'
import V32AdminSystemPage from '../../../../src/v32/pages/admin/AdminSystemPage.tsx'
import V32AdminSystemHealthPage from '../../../../src/v32/pages/admin/SystemHealthPage.tsx'
import V32AdminEventsPage from '../../../../src/v32/pages/admin/AdminEventsPage.tsx'
import V32AdminFeatureFlagsPage from '../../../../src/v32/pages/admin/AdminFeatureFlagsPage.tsx'
import V32AdminIngredientUnitsPage from '../../../../src/v32/pages/admin/AdminIngredientUnitsPage.tsx'
import V32AdminApiDocsPage from '../../../../src/v32/pages/admin/ApiDocsPage.tsx'
import V32AdminSemanticDiscoveryPage from '../../../../src/v32/pages/admin/AdminSemanticDiscoveryPage.tsx'
import V32AdminRetentionPage from '../../../../src/v32/pages/admin/AdminRetentionPage.tsx'
import { RetentionInsightsPage } from '../../../../src/client/admin/RetentionInsightsPage.tsx'
import { NavDemo as NavDemoPage } from '../../../../src/v32/pages/NavDemo.tsx'
import { RecipeExperienceDemo as RecipeExperiencePage } from '../../../../src/v32/pages/RecipeExperienceDemo.tsx'
import Receipt2RecipePage from '../../../../src/pages/Receipt2RecipeComingSoon.tsx'
import { TermsPage } from '../../../../src/legal/TermsPage.tsx'
import { PrivacyPage } from '../../../../src/legal/PrivacyPage.tsx'
import { OnboardingPage } from '../../../../src/routes/OnboardingPage.tsx'
import { TasksPage } from '../../../../src/tasks/TasksPage.tsx'
import { PlanDetail as V32PlanDetailPage } from '../../../../src/v32/pages/plans/PlanDetail.tsx'
import AdminPage from '../../../../src/routes/AdminPage.tsx'
import V32AdminOverviewPage from '../../../../src/v32/pages/admin/AdminOverviewPage.tsx'
import AdminRevenuePage from '../../../../src/routes/admin/AdminRevenuePage.tsx'
import V32AdminScrapedRecipesPage from '../../../../src/v32/pages/admin/ScrapedRecipesPage.tsx'
import { HouseholdManagement as HouseholdManagementPage } from '../../../../src/components/HouseholdManagement'
import AdHocCostingPage from '../../../../src/v32/pages/ims/AdHocCostingPage'
import { AdminUsagePage } from '../../../../src/v32/pages/admin/AdminUsagePage'
import { BetaLandingPage } from '../../../../src/v32/components/BetaLandingPage.tsx'
import AdminBetaWaitlistPage from '../../../../src/v32/pages/admin/AdminBetaWaitlistPage.tsx'

import { OAuthCallbackPage } from "./auth/pages/OAuthCallback"

import { DefaultRootErrorBoundary } from './components/DefaultRootErrorBoundary'

import { routes } from 'wasp/client/router'

export const routeNameToRouteComponent = {
  LoginRoute: LoginPage,
  SignupRoute: SignupPage,
  RequestPasswordResetRoute: RequestPasswordResetPage,
  PasswordResetRoute: PasswordResetPage,
  EmailVerificationRoute: EmailVerificationPage,
  VerifyEmailLandingRoute: VerifyEmailLandingPage,
  LandingRoute: LandingPage,
  AppLayoutRoute: createAuthRequiredPage(AppLayoutPage),
  DashboardRoute: createAuthRequiredPage(V32DashboardPage),
  DiscoverRoute: createAuthRequiredPage(V32RecipePage),
  MyRecipesRoute: createAuthRequiredPage(V32MyRecipesPage),
  RecipeManagerRoute: createAuthRequiredPage(RecipeManagerPage),
  FavoritesRoute: createAuthRequiredPage(V32FavoritesRedirectPage),
  SharedRecipeRoute: SharedRecipePage,
  PlansRoute: createAuthRequiredPage(V32PlansPage),
  ShoppingListRoute: createAuthRequiredPage(ShoppingListPage),
  ComingSoonRoute: createAuthRequiredPage(ComingSoonPage),
  NutritionRoute: createAuthRequiredPage(AnalyticsDashboardPage),
  RecipeDetailRoute: createAuthRequiredPage(V32RecipeDetailPage),
  CookingModeRoute: createAuthRequiredPage(V32CookingModePage),
  RecipeRedirectRoute: createAuthRequiredPage(RecipeRedirectPage),
  CreateCustomRecipeRoute: createAuthRequiredPage(V32CreateCustomRecipePage),
  SemanticSearchTestRoute: createAuthRequiredPage(V32SemanticSearchTestPage),
  ProfileRoute: createAuthRequiredPage(StandardProfilePage),
  KitchenProfileRoute: createAuthRequiredPage(V32ProfilePage),
  BillingRoute: createAuthRequiredPage(V32SettingsPage),
  AccountBillingRoute: createAuthRequiredPage(V32SettingsPage),
  SettingsRoute: createAuthRequiredPage(V32SettingsPage),
  PricingRoute: V32PricingPage,
  BetaPricingRoute: BetaPricingPage,
  AdminUsageRoute: createAuthRequiredPage(V32AdminUsagePage),
  AdminPlansRoute: createAuthRequiredPage(V32AdminPlansPage),
  AdminBillingRoute: createAuthRequiredPage(V32AdminBillingPage),
  AdminAIRoute: createAuthRequiredPage(V32AdminAIPage),
  AdminSystemRoute: createAuthRequiredPage(V32AdminSystemPage),
  AdminSystemHealthRoute: createAuthRequiredPage(V32AdminSystemHealthPage),
  AdminEventsRoute: createAuthRequiredPage(V32AdminEventsPage),
  AdminFeatureFlagsRoute: createAuthRequiredPage(V32AdminFeatureFlagsPage),
  AdminIngredientUnitsRoute: createAuthRequiredPage(V32AdminIngredientUnitsPage),
  AdminApiDocsRoute: createAuthRequiredPage(V32AdminApiDocsPage),
  AdminSemanticDiscoveryRoute: createAuthRequiredPage(V32AdminSemanticDiscoveryPage),
  AdminRetentionRoute: createAuthRequiredPage(V32AdminRetentionPage),
  RetentionInsightsRoute: createAuthRequiredPage(RetentionInsightsPage),
  NavDemoRoute: NavDemoPage,
  RecipeExperienceRoute: RecipeExperiencePage,
  Receipt2RecipeRoute: Receipt2RecipePage,
  TermsRoute: TermsPage,
  PrivacyRoute: PrivacyPage,
  OnboardingRoute: createAuthRequiredPage(OnboardingPage),
  TasksRoute: createAuthRequiredPage(TasksPage),
  PlanDetailRoute: createAuthRequiredPage(V32PlanDetailPage),
  AdminRoute: createAuthRequiredPage(AdminPage),
  AdminOverview: createAuthRequiredPage(V32AdminOverviewPage),
  AdminRevenue: createAuthRequiredPage(AdminRevenuePage),
  AdminScrapedRecipesRoute: createAuthRequiredPage(V32AdminScrapedRecipesPage),
  HouseholdRoute: createAuthRequiredPage(HouseholdManagementPage),
  AdHocCostingRoute: createAuthRequiredPage(AdHocCostingPage),
  AdminUsageManagementRoute: createAuthRequiredPage(AdminUsagePage),
  BetaLandingRoute: BetaLandingPage,
  AdminBetaWaitlistRoute: createAuthRequiredPage(AdminBetaWaitlistPage),
} as const;

const waspDefinedRoutes = [
  {
    path: "/oauth/callback",
    Component: OAuthCallbackPage,
  },
]
const userDefinedRoutes = Object.entries(routes).map(([routeKey, route]) => {
  return {
    path: route.to,
    Component: routeNameToRouteComponent[routeKey],
  }
})

const browserRouter = createBrowserRouter([{
  path: '/',
  element: <App />,
  ErrorBoundary: DefaultRootErrorBoundary,
  children: [
    ...waspDefinedRoutes,
    ...userDefinedRoutes,
  ],
}])

export const router = <RouterProvider router={browserRouter} />
